import { useContext } from "react";
import type { IChatbotContext } from "../../chatbot.context";
import { ChatbotContext } from "../../chatbot.context";

export function useChatbotContext(): IChatbotContext {
  const context = useContext(ChatbotContext);
  return context;
}
